import { render, staticRenderFns } from "./mainactivity.vue?vue&type=template&id=5e200b81&"
import script from "./mainactivity.vue?vue&type=script&lang=js&"
export * from "./mainactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports